module.exports = __webpack_public_path__ + "static/cool-background-9fcbf058f394c626c4c00dcaa1789202.png";